import { focusRing } from "./focusRing";
/** @deprecated use `focusRing({ type: "native" })` */
export const nativeFocusRing = () => focusRing({ type: "native" });
